import trackEventsBQ from '../analyticsBQ'
import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

import { FeedbackEvents } from './userFeedbackAnalytics.types'

class userFeedbackAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.USER_FEEDBACK)
  }

  public logUserFeedbackModalOpen(): void {
    this.logButtonClick('user_feedback_form_open')
  }

  public logTypeformSeen(typeformId: string): void {
    const event = {
      event: FeedbackEvents.TYPEFORM_SEEN,
      typeformId,
    }

    trackEventsBQ(event)
  }

  public logTypeformOpened(typeformId: string): void {
    const event = {
      event: FeedbackEvents.TYPEFORM_OPENED,
      typeformId,
    }

    trackEventsBQ(event)
  }

  public logTypeformFinished(typeformId: string): void {
    const event = {
      event: FeedbackEvents.TYPEFORM_FINISHED,
      typeformId,
    }

    trackEventsBQ(event)
  }

  public logTypeformClosed(typeformId: string): void {
    const event = {
      event: FeedbackEvents.TYPEFORM_CLOSED,
      typeformId,
    }

    trackEventsBQ(event)
  }
}

export default new userFeedbackAnalytics()
